export default __webpack_public_path__ + "static/media/logo-xl-2048w.b009ba2b.webp";